import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  DOCUMENT,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faBell,
  faCalendarAlt,
  faCalendarCheck,
  faCogs,
  faCreditCard,
  faUserCheck,
  faUserCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { SharedUserService } from '../shared/services/shared/user/shared-user.service';
import { isPlatformBrowser } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Meta, Title } from '@angular/platform-browser';
import { NavbarControlComponent } from '../shared/controls/navbar-control/navbar-control.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { loadComponentTranslations } from '../shared/funcs/lang-loader';
import { FooterComponent } from '../shared/controls/footer/footer.component';
const desc =
  'ClockFlex is an online appointment scheduling and booking software for service businesses to manage clients, bookings, and calendars in one place.';

@Component({
  selector: 'app-about',
  imports: [
    RouterModule,
    FontAwesomeModule,
    NgbDropdownModule,
    NavbarControlComponent,
    TranslateModule,
    FooterComponent,
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements OnInit, AfterViewInit {
  public faBell: IconDefinition = faBell;
  public faCalendarAlt: IconDefinition = faCalendarAlt;
  public faCalendarCheck: IconDefinition = faCalendarCheck;
  public faUserCheck: IconDefinition = faUserCheck;
  public faCogs: IconDefinition = faCogs;
  public faCreditCard: IconDefinition = faCreditCard;
  public faUserCircle: IconDefinition = faUserCircle;

  public isLoggedIn: boolean = false;

  constructor(
    private titleService: Title,
    private _http: HttpClient,
    private _router: Router,
    private _translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document,
    private _sharedUserService: SharedUserService,
  ) {}

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  private setCanonicalUrl(url: string): void {
    if (!url.startsWith('http')) {
      return;
    }

    let link: HTMLLinkElement | null = this.document.querySelector(
      "link[rel='canonical']",
    );

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    link.setAttribute('href', url);
  }

  public ngOnInit(): void {
    // ✅ Title (keep sales-focused if this is HOMEPAGE)
    this.titleService.setTitle(
      'Scheduling & Booking Software for Service Businesses | ClockFlex',
    );

    // ✅ Canonical (IMPORTANT: metaService cannot set canonical)
    const canonicalUrl = `https://clockflex.com${this._router.url.split('?')[0]}`;
    this.setCanonicalUrl(canonicalUrl);

    // ✅ Meta Description
    this.metaService.updateTag({
      name: 'description',
      content: desc,
    });

    // ❌ REMOVED meta robots
    // Reason: Already controlled via X-Robots-Tag in server.ts

    // ✅ Open Graph
    this.metaService.updateTag({
      property: 'og:title',
      content:
        'Scheduling & Booking Software for Service Businesses | ClockFlex',
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: desc,
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: canonicalUrl,
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.metaService.updateTag({
      property: 'og:site_name',
      content: 'ClockFlex',
    });

    // ✅ Twitter
    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.metaService.updateTag({
      name: 'twitter:title',
      content:
        'Scheduling & Booking Software for Service Businesses | ClockFlex',
    });

    this.metaService.updateTag({
      name: 'twitter:description',
      content: desc,
    });

    this.metaService.updateTag({
      name: 'twitter:image',
      content: 'https://clockflex.com/assets/images/og-image.png',
    });
    this.subscribeUserService();
  }

  public ngAfterViewInit(): void {
    loadComponentTranslations(
      this._http,
      this._translateService,
      'components/about',
      this.isBrowser(),
    ).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  private subscribeUserService(): void {
    this._sharedUserService.loggedIn$.subscribe((response) => {
      this.isLoggedIn = response ? true : false;
    });
  }
}
